import { FC } from 'react';

// Components
import { TeamImagePlaceholderIcon } from '@velinsi/smp-widgets-ui';

interface Props {
  squad_image: string;
  showImage: boolean;
}

const TeamImage: FC<Props> = ({ squad_image, showImage }) => {
  if (!showImage) return null;

  return (
    <>
      {squad_image ? (
        <img className='team-squad-image h-[210px] mb-0 sm:mb-2 w-full' src={squad_image} />
      ) : (
        <div className='empty-team-squad-image-container flex justify-center items-center h-[210px] bg-emptyTeamImage rounded-4  w-full mb-0 sm:mb-2'>
          <TeamImagePlaceholderIcon />
        </div>
      )}
    </>
  );
};

export default TeamImage;
